/* ✅️ カート機能に関する処理をまとめたファイル */
$(function() {
	const $doc = $(document);

	$doc.on('click', '.add_to_cart', onClickAddToCart);

	initFeatureCart();
})

/**
 * カート機能初期化処理
 */
function initFeatureCart() {
	updateCartCount(); // カートのカウント更新
}

/**
 * カートに追加ボタンクリック時処理
 * @param e
 */
function onClickAddToCart(e) {
	e.preventDefault();
	var $btn = $(this);

	if ($btn.data('atcProcessing')) return;
	$btn.data('atcProcessing', true);
	var originalText = $btn.text();
	$btn.text('追加中...');

	var variantId = $btn.data('variantId') || $btn.data('variant_id') || null;
	var quantity = parseInt($btn.data('qty') || $btn.data('quantity') || '1', 10) || 1;
	var handle = $btn.data('productHandle') || $btn.data('product_handle') || null;

	var addPromise = variantId
		? $.Deferred().resolve(variantId).promise()
		: fetchFirstAvailableVariant(handle);

	addPromise
		.then(function(id) {
			return addToCart(id, quantity);
		})
		.done(function() {
			toast('カートに追加しました');
			updateCartCount();
			showDrawerCart(); // ✅️ ドロワカートを表示 (不要な場合はコメントアウト)
		})
		.fail(function(err) {
			console.error(err);
			toast('カート追加に失敗しました', true);
		})
		.always(function() {
			$btn.text(originalText);
			$btn.removeData('atcProcessing');
		});
}


/**
 * トーストを表示
 * @param message
 * @param isError
 */
function toast(message, isError) {
	var $t = $('<div class="simple-toast">').text(message).css({
		position: 'fixed',
		right: '20px',
		bottom: '20px',
		padding: '10px 14px',
		background: isError ? '#c33' : '#333',
		color: '#fff',
		borderRadius: '6px',
		zIndex: 9999,
		boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
	});
	$('body').append($t);
	setTimeout(function() { $t.fadeOut(300, function() { $(this).remove(); }); }, 3000);
}

/**
 * カート内のカウントを更新
 */
function updateCartCount() {
	$.getJSON('/cart.js', function(cart) {
		if (cart.item_count > 0) {
			const style = {opacity: 1};
			let cartCountText = cart.item_count;
			// カート内に99点以上商品がある場合は表示を調整
			if (cart.item_count > 99) {
				cartCountText = '99+';
				style.fontSize = '.9rem';
			}
			$('.cart-count-bubble').text(cartCountText).css(style);
		}
	});
}

/**
 * カートに商品を追加
 * @param variantId
 * @param quantity
 * @return {*}
 */
function addToCart(variantId, quantity) {
	return $.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data: JSON.stringify({ id: variantId, quantity: quantity }),
		dataType: 'json',
		contentType: 'application/json',
		cache: false
	});
}

/**
 * 最初の「有効な」variantを取得
 * @param handle
 * @return {*}
 */
function fetchFirstAvailableVariant(handle) {
	var dfd = $.Deferred();
	if (!handle) {
		dfd.reject('Handle not provided');
		return dfd.promise();
	}
	$.getJSON('/products/' + handle + '.js')
		.done(function(product) {
			if (!product || !product.variants) {
				dfd.reject('No variants found');
				return;
			}
			var available = product.variants.find(function(v) { return v.available; }) || product.variants[0];
			if (available) {
				dfd.resolve(available.id);
			} else {
				dfd.reject('No available variant');
			}
		})
		.fail(function() {
			dfd.reject('Failed to fetch product');
		});
	return dfd.promise();
}

/**
 * ドロワカートを表示
 */
function showDrawerCart() {
	// nop（あとで実装）
}
